import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { startDatadogView } from './datadogViews';

/**
 * Tracks Datadog RUM views on route changes.
 *
 * Mount once inside <CompatRouter> so useLocation() has access to the router
 * context.  Each pathname change fires startDatadogView, which resolves the
 * route definition pattern and calls datadogRum.startView() — giving Datadog
 * low-cardinality, human-readable view names instead of raw URLs.
 *
 * Uses useLayoutEffect (not useEffect) so the first startView() call fires
 * synchronously after React commits but before the browser paints — ensuring
 * page load performance metrics (LCP, FCP, TTFB) are attributed to a named
 * view rather than lost in the gap between SDK init and first render.
 *
 * Requires `trackViewsManually: true` in the RUM init config (set in runtime.ts).
 */
export function DatadogRouteTracker() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    startDatadogView(pathname);
  }, [pathname]);

  return null;
}
